import { Component, OnInit, ViewChild, ElementRef, Input, ViewChildren, Renderer2, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { StateService, AuthService, AuctionService, AuctionLotService, MyAuctionLotService } from '../../../services';
import { FormFunctions } from '../../../functions';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { } from '../../../shared/modals';
import { AuctionLotSearchSortType } from 'src/app/models/auction-lot-search-sort-type';
import { AppConfig } from 'src/app/config';
import { fadeAnimation } from 'src/app/shared/animations';
import { AuctionModel, AuctionLotSearchFilters } from 'src/app/models';

@Component({
    selector: 'page-manage-auction-filters',
    styleUrls: ['./page-manage-auction-filters.component.scss'],
    templateUrl: './page-manage-auction-filters.component.html',
    animations: [fadeAnimation],
})
export class PageManageAuctionFiltersComponent implements OnInit {
    processing: boolean = false;
    initialized: boolean = false;
    filters: AuctionLotSearchFilters = new AuctionLotSearchFilters();

    constructor(public router: Router,
        private appConfig: AppConfig,
        private activatedRoute: ActivatedRoute,
        public stateService: StateService,
        private modalService: NgbModal,
        public authService: AuthService,
        public auctionService: AuctionService,
        public auctionLotService: AuctionLotService,
        public myAuctionLotService: MyAuctionLotService,
        public formFunctions: FormFunctions
    ) {
        var me = this;
    }

    ngOnInit() {
        let me = this;
        // Wait until the default auction is loaded
        me.initialized = true;
    }

    Updated() {
        // console.log('Updated');
    }

    Cleared() {
        // console.log('Cleared');
        this.auctionLotService.filters = this.auctionLotService.GetDefaultFilters();
    }
}
